import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { navigate } from '@reach/router';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { MenuItem, Divider, Typography } from '@material-ui/core';
import Rating from '@material-ui/lab/Rating';
import { withStyles } from '@material-ui/core/styles';
import { ArrowNext, Header } from '../../components';
import { POI_ACTION_TYPES, WS_ACTION_TYPES } from '../../redux-saga/actionTypes';
import { commands } from '../../constants/index';
import styles from './styles';

const { selectPoiCommand } = commands;

class PoiList extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  /**
   * @method selectedPoi sends selected POI index to NaviClient.
   * Save selected POI to redux and navigate to Poi Details Screen.
   */
  selectedPoi = (value, index) => {
    const {
      sendMessageToSocket,
      addStopInProgressStatus,
      saveSelectedStop,
      saveSelectedPoi,
      markSinglePoi,
    } = this.props;
    sendMessageToSocket(selectPoiCommand(index));
    if (addStopInProgressStatus) {
      saveSelectedStop(value);
    } else {
      saveSelectedPoi(value);
    }
    markSinglePoi(true);
    navigate('destinationInformation');
  };

  /**
   * @method getCloseTime returns POI closing time
   */
  getCloseTime = data => {
    const [time] = data;
    const { closeTime } = time;
    return closeTime;
  };

  render() {
    const {
      classes,
      list,
      t,
      // filteredList,
      // filteredCriteria,
      search: { title },
    } = this.props;

    if (!list) {
      return null;
    }

    // const poiList =
    //   filteredCriteria.price === '*' &&
    //   filteredCriteria.rating === '*' &&
    //   filteredCriteria.openNow === false
    //     ? list
    //     : filteredList;
    return (
      <React.Fragment>
        <Header title={`${title || ''} (${list.length})`} />
        <Divider className={classes.divider} />
        <div className={classes.scroll__wheel}>
          {list.map((locations, index) => {
            const {
              id,
              name,
              distanceValue,
              timeValue,
              latitude,
              longitude,
              poi: {
                rating,
                category_types,
                open_now,
                openHours,
                marketEnabled,
                price_level,
                permanentlyClosed,
              },
            } = locations;
            return (
              <React.Fragment>
                <MenuItem
                  key={id}
                  className={classes.menuItem__container}
                  onClick={() => this.selectedPoi(locations, index)}
                >
                  <div className={classes.list__container}>
                    <Typography className={classes.left__alphabet}>
                      {String.fromCharCode('A'.charCodeAt() + index)}
                    </Typography>
                    <div className={classes.center__container}>
                      {name !== undefined ? (
                        <Typography className={classes.title__text}>
                          {name}
                          {marketEnabled === true ? (
                            <i className={`material-icons ${classes.mp}`}>local_mall</i>
                          ) : null}
                        </Typography>
                      ) : (
                        <Typography className={classes.title__text}>
                          {latitude}
                          {t('poi-list.label.comma')} {longitude}
                          {marketEnabled === true ? (
                            <i className={`material-icons ${classes.mp}`}>local_mall</i>
                          ) : null}
                        </Typography>
                      )}
                      {rating !== undefined ? (
                        <div className={classes.display__flex}>
                          <Typography className={classes.subtitle}>{rating}&nbsp;</Typography>
                          <Rating
                            className={classes.star__rated}
                            name="rating"
                            value={rating}
                            precision={0.1}
                          />
                        </div>
                      ) : null}
                      <span className={classes.display__flex}>
                        {category_types !== undefined ? (
                          <Typography className={classes.subtitle}>{category_types}</Typography>
                        ) : null}
                        {price_level !== undefined ? (
                          <React.Fragment>
                            <span className={classes.dot}>{t('poi-list.label.dot')}</span>
                            <Typography className={classes.subtitle}>{price_level}</Typography>
                          </React.Fragment>
                        ) : null}
                      </span>
                      <span className={classes.display__flex}>
                        {open_now && !permanentlyClosed ? (
                          <Typography className={classes.subtitle}>
                            {t('poi-list.label.open-now')}
                          </Typography>
                        ) : null}
                        {!open_now && !permanentlyClosed ? (
                          <Typography className={classes.subtitle}>
                            {t('poi-list.label.closed')}
                          </Typography>
                        ) : null}
                        {open_now && !permanentlyClosed && openHours !== undefined ? (
                          <React.Fragment>
                            <Typography className={classes.dot}>
                              {t('poi-list.label.dot')}
                            </Typography>
                            <Typography className={classes.subtitle}>
                              {t('poi-list.label.closes')}&nbsp;
                            </Typography>
                            <Typography className={classes.close__hour}>
                              {this.getCloseTime(openHours)}
                            </Typography>
                          </React.Fragment>
                        ) : null}
                        {!open_now && permanentlyClosed ? (
                          <Typography className={classes.close__hour}>
                            {t('poi-list.label.permanently-closed')}
                          </Typography>
                        ) : null}
                      </span>
                      <span className={classes.display__flex}>
                        {timeValue !== undefined ? (
                          <Typography className={classes.subtitle}>{timeValue}</Typography>
                        ) : null}
                        {distanceValue !== undefined ? (
                          <span className={classes.display__flex}>
                            <span className={classes.dot}>{t('poi-list.label.dot')}</span>
                            <Typography className={classes.subtitle}>{distanceValue}</Typography>
                          </span>
                        ) : null}
                      </span>
                    </div>
                    <ArrowNext />
                  </div>
                </MenuItem>
                <Divider />
              </React.Fragment>
            );
          })}
        </div>
        <div className={classes.overlay} />
      </React.Fragment>
    );
  }
}

PoiList.propTypes = {
  t: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  list: PropTypes.array,
  search: PropTypes.object,
  saveSelectedPoi: PropTypes.func.isRequired,
  sendMessageToSocket: PropTypes.func.isRequired,
  saveSelectedStop: PropTypes.func.isRequired,
  addStopInProgressStatus: PropTypes.bool.isRequired,
  markSinglePoi: PropTypes.func.isRequired,
  // filteredList: PropTypes.array,
  // filteredCriteria: PropTypes.object,
};

PoiList.defaultProps = {
  // filteredList: [],
  // filteredCriteria: {},
  list: [],
  search: {
    title: '',
  },
};

const mapStateToProps = ({ poi }) => ({
  list: poi.poi_list,
  search: poi.search_response,
  addStopInProgressStatus: poi.stops_inprogress,
  // filteredList: poi.filtered_list,
  // filteredCriteria: poi.filter_criteria_list,
});

const mapDispatchToProps = dispatch => ({
  saveSelectedPoi: payload => dispatch({ type: POI_ACTION_TYPES.POI_SELECTED.LOADING, payload }),
  sendMessageToSocket: payload => dispatch({ type: WS_ACTION_TYPES.WS.ON_COMMANDS, payload }),
  saveSelectedStop: payload => dispatch({ type: POI_ACTION_TYPES.STOPS, payload }),
  markSinglePoi: payload =>
    dispatch({ type: POI_ACTION_TYPES.NAVIGATION_STATE.SINGLE_POI, payload }),
});

export default withStyles(styles)(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(withTranslation()(PoiList)),
);
